import { memo } from 'react'
import { alpha, Button, styled, Typography } from '@mui/material'
import { FormatListBulletedIcon } from '@weblite/icons'
import { ArrowIOSIcon } from '$common/icons'
import { CourseVitrineWappPanel } from '$logic/wapp-panels'
import { t } from '$i18n'
import { COURSE_VITRINE_BUTTON_HEIGHT } from '$comp/_app/components/chat/components/conf'

const StyledButton = styled(Button)`
  /* @noflip */
  padding: 0 12px 0 8px;
  margin: 6px;
`

interface ContainerProps {
  offset: number
}

const Container = styled(StyledButton)<ContainerProps>(({ theme }) => ({
  direction: 'rtl',
  height: `${COURSE_VITRINE_BUTTON_HEIGHT}px`, // TODO: merge with channel-button
  border: `1px solid`,
  borderColor: alpha(theme.palette.neutral1000, 0.15),
  borderRadius: '24px',
  backgroundColor: theme.palette.yellow500,
  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.25)',

  '&:hover': {
    backgroundColor: theme.palette.yellow500,
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.25)',
  },
  zIndex: 2,
}))

const StyledTypography = styled(Typography)`
  margin: 0 4px;
`

export const ChannelCourseVitrineButton = memo(
  ({ roomId, expanded }: { roomId: string; expanded: boolean }) => {
    return (
      <Container
        offset={0}
        onClick={() => CourseVitrineWappPanel.open({ roomId, isAdmin: true })}
      >
        <FormatListBulletedIcon
          sx={{ color: 'neutral900', width: '20px', height: '20px' }}
        />
        {expanded && (
          <StyledTypography color="neutral900" variant="subtitle4">
            {t('chat.courseVitrine')}
          </StyledTypography>
        )}

        <ArrowIOSIcon
          sx={{ color: 'neutral900', width: '20px', height: '20px' }}
        />
      </Container>
    )
  },
)
